import { Component } from '@angular/core';

@Component({
  selector: 'app-post-card-demo',
  templateUrl: './post-card-demo.component.html',
})
export class PostCardDemoComponent {}
